export default "__VITE_ASSET__MO25$mdh__"